export const DISCORD_GUILD_ID = '765488058173751296'
